<template>
    <div class="gofixInput gofixDropdownInput"
         v-bind:class="{
            gofixInputHasDesc:desc,
            gofixInputError : (required && !value && blurInput),
            gofixInputDisable:disabled,
            gofixInputNoLabel:!label,
            gofixInputNotCapitalizeLabel: disableCapitalizeLabel,
            gofixInputNotDropdown: noDrop
         }">
        <div class="mainInput">
            <v-select
                    :searchable="searchable"
                    :value="value"
                    :options="options"
                    :label="vLabel"
                    :reduce="reduce"
                    :clearable="clearable"
                    :filterable="filterable"
                    :taggable="taggable"
                    :push-tags="pushTags"
                    :multiple="multiple"
                    :disabled="disabled"
                    :getOptionLabel="getOptionLabel"
                    :placeholder="placeholder"
                    :selectable="selectable"
                    class="gofixVueSelect gofixDropdown"
                    v-bind:class="{'vs--selected' : (value !== null && value !== '')}"
                    @input="handleInput"
                    @search="emitSearch"
                    :calculate-position="calculatePosition"
                    @search:blur="blurInput = true"
                    :append-to-body="appendToBody"
                    :noDrop="noDrop"
            >
                <template #option="footer">
                    <slot name="gofixInput:dropdown:footer"></slot>
                </template>
                <template #header>
                    <slot name="gofixInput:dropdown:header"></slot>
                </template>
                <template #list-footer>
                    <slot name="gofixInput:dropdown:list-footer"></slot>
                </template>
                <template #list-header>
                    <slot name="gofixInput:dropdown:list-header"></slot>
                </template>
                <template #no-options="{ search, searching, loading }">
                    <slot name="gofixInput:dropdown:no-options" v-bind="{ search, searching, loading }"></slot>
                </template>
                <template #open-indicator="{ attributes }">
                    <slot name="gofixInput:dropdown:open-indicator" v-bind="{ attributes }"></slot>
                </template>
                <template #option="option">
                    <slot name="gofixInput:dropdown:option" v-bind="option"></slot>
                </template>
                <template #search="{ attributes, events }">
                    <slot name="gofixInput:dropdown:search" v-bind="{ attributes, events }"></slot>
                </template>
                <template #selected-option="option">
                    <slot name="gofixInput:dropdown:selected-option" v-bind="option"></slot>
                </template>
                <template #selected-option-container="option">
                    <slot name="gofixInput:dropdown:selected-option-container" v-bind="option"></slot>
                </template>
                <template #spinner="{ loading }">
                    <slot name="gofixInput:dropdown:spinner" v-bind="{loading}"></slot>
                </template>
            </v-select>
            <div class="label" :class="classLabel">{{label}}<span class="iconRequired" v-if="showIconRequired && required">*</span></div>
        </div>
        <p class="desc" v-if="desc" v-html="desc"></p>
        <slot name="gofixInput:text:after-desc"></slot>
    </div>
</template>

<script>
    import { createPopper } from '@popperjs/core';
    export default {
        name: "dropdown-supplier",
        props: {
            label: {
                type: String,
                required: false,
                default: () => "Select default"
            },
            classLabel: {
                type: String,
                required: false,
                default: ""
            },
            showIconRequired: {
                type: Boolean,
                required: false,
                default: () => false
            },
            value: {
                default: () => null
            },
            desc: {
                type: String,
                required: false,
                default: () => null
            },
            options: {
                type: Array,
                required: true,
                default: () => []
            },
            vLabel:{
                type: String,
                required: false,
                default: () => "label"
            },
            placeholder:{
                type: String,
                required: false,
                default: () => null
            },
            reduce: {
                type: Function,
                default: option => option,
            },
            filterable: {
                type: Boolean,
                default: true
            },
            searchable: {
                type: Boolean,
                default: true
            },
            required: {
                type: Boolean,
                required: false,
                default: () => false
            },
            clearable: {
                type: Boolean,
                default: true
            },
            taggable: {
                type: Boolean,
                default: false
            },
            pushTags: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            multiple: {
                type: false,
                default: false
            },
            disableCapitalizeLabel: {
                type: false,
                default: false
            },
            appendToBody: {
                type: Boolean,
                required: false,
                default: () => false
            },
            placement: {
                type: String,
                required: false,
                default: () => "bottom"
            },
            selectable: {
                type: Function,
                required: false,
                default:  option => true
            },
            getOptionLabel: {
                type: Function,
                default(option) {
                    if (typeof option === 'object') {
                        if (!option.hasOwnProperty(this.label)) {
                            return console.warn(
                                `[vue-select warn]: Label key "option.${this.label}" does not` +
                                ` exist in options object ${JSON.stringify(option)}.\n` +
                                'https://vue-select.org/api/props.html#getoptionlabel'
                            )
                        }
                        return option[this.label]
                    }
                    return option;
                }
            },
            noDrop: {
                type: Boolean,
                required: false,
                default: () => false
            }
        },

        data() {
            return {
                allSuppliers: null,
                activeLevel: 1,
                suppliers:[],
                loading: false,
                blurInput: false,
            }
        },
        watch: {


        },
        created(){

        },
        methods: {

            handleInput (e) {
                this.$emit("input", e);
                this.$emit("change", e);
            },
            emitSearch(search, loading){
                this.$emit("search", search, loading);
            },
            calculatePosition (dropdownList, component, {width}) {
                dropdownList.style.width = width;
                const popper = createPopper(component.$refs.toggle, dropdownList, {
                    placement: this.placement,
                    modifiers: [
                        {
                            name: 'offset', options: {
                                offset: [0, -1]
                            }
                        },
                        {
                            name: 'toggleClass',
                            enabled: true,
                            phase: 'write',
                            fn ({state}) {
                                component.$el.classList.toggle('drop-up', state.placement === 'top')
                            },
                        }]
                });
                return () => popper.destroy();
            }
        }
    }
</script>

<style scoped>

</style>
